import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmDeliveredToConsumer({
  id_order,
  ...payload
}) {
  return await post(`/clouders/orders/${id_order}/deliverConsumer`, payload);
}
